import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Avatar,
  Typography,
  Button,
  Stack,
  LinearProgress,
  Divider,
} from "@mui/material";
import api from "../api/axios";
import perfil from "../assets/perfil.png";

import {
  CommonSubHeader,
  useLocationHelpers,
} from "../Components/helpers/Helpers";

import { useContext } from "react";
import { UserContext } from "../Components/Context/Context";
import ChangePassword from "../Components/ChangePassword";

function Perfil() {
  const { goPanel } = useLocationHelpers();

  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const { userData: contextUserData, logout } = useContext(UserContext);

  const getUser = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/getuserlogged`,
      );
      setUserData(data.user);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  const imageUrl =
    contextUserData?.userCompany?.id &&
    contextUserData?.userCompany?.company_logo
      ? `${process.env.REACT_APP_BACKEND_HOST}/storage/company/${contextUserData.userCompany.id}/${contextUserData.userCompany.company_logo}`
      : perfil;

  const infoItems = [
    { label: "Nombre", value: userData?.name },
    { label: "Apellido", value: userData?.surname },
    { label: "Email", value: userData?.email },
    { label: "Dirección", value: userData?.address },
    { label: "Provincia", value: userData?.province },
    { label: "Código Postal", value: userData?.postalcode },
    { label: "Teléfono", value: userData?.phone },
  ];

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Mis Datos" />

      {loading && <LinearProgress color="success" />}

      {!loading && userData && (
        <Grid container justifyContent="center" sx={{ mt: 2 }}>
          {/* PERFIL */}
          <Grid item xs={12} md={8} lg={6} p={2}>
            <Card elevation={3}>
              <CardHeader
                avatar={
                  <Avatar src={imageUrl} sx={{ width: 72, height: 72 }} />
                }
                title={
                  <Typography variant="h6">
                    {contextUserData?.userCompany?.company_name}
                  </Typography>
                }
                subheader="Información del usuario"
              />

              <Divider />

              <CardContent>
                <Grid container spacing={2}>
                  {infoItems.map(({ label, value }) => (
                    <Grid item xs={12} sm={6} key={label}>
                      <Typography variant="caption" color="text.secondary">
                        {label}
                      </Typography>
                      <Typography variant="body1">{value || "-"}</Typography>
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* ACCIONES */}
          <Grid item xs={12} md={8} lg={6} p={2}>
            <Card elevation={2}>
              <CardHeader title="Acciones" subheader="Gestión de la cuenta" />
              <Divider />

              <CardContent>
                <Stack spacing={2}>
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => setOpenDialog(true)}>
                    Cambiar contraseña
                  </Button>

                  <Button variant="outlined" onClick={goPanel}>
                    Ir al panel
                  </Button>

                  <Button variant="outlined" color="error" onClick={logout}>
                    Cerrar sesión
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>

          <ChangePassword
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            userLogged={contextUserData}
          />
        </Grid>
      )}
    </div>
  );
}

export default Perfil;
